module.exports = __webpack_public_path__ + "bs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bs.svg
// module id = 465
// module chunks = 0